import { Typography } from "@mui/material";
import styled from "styled-components";
import Button from "components/Buttons/ThemeButton";

export const Container = styled.div<{ scale: number }>`
	width: 100%;
	padding: 0px;
	width: 21.43em;
	height: 27.81em;
	position: relative;
	display: flex;
	/* align-items: center;
	justify-content: center; */
	flex-direction: column;
	overflow: hidden;
	border-radius: 18px;
	font-size: 1rem;
	transform: scale(${(props) => props.scale});
	box-shadow: 0 0.32em 1em 0 rgba(0, 0, 0, 0.15);
	background-color: #fff;

	@media (orientation: landscape) {
		width: 56.87em;
		height: 25.69em;
	}
`;

export const Header = styled.div<{
	$backgroundImage: string;
}>`
	position: relative;
	width: 100%;
	height: 11em;
	flex-shrink: 0;
	display: flex;
	//align-items: center;
	justify-content: center;
	background-image: url(${(props) => props.$backgroundImage});
	background-size: cover;
	background-position: top center;
	background-repeat: no-repeat;

	@media (orientation: landscape) {
		background-position: center center;
	}
`;

export const DataContainer = styled.div`
	position: absolute;
	width: 100%;
	height: 100%;
	top: 13%;
	flex: 1;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;

	@media (orientation: landscape) {
		top: 11.5%;
	}
`;

export const SwiperContainer = styled.div`
	width: 100%;
	.swiper-slide {
		width: 17.3em !important;
	}
	.swiper-slide:first-child {
		margin-left: 2.2em;
	}

	@media (orientation: landscape) {
		font-size: 0.9em;
		display: flex;
		justify-content: center;
		align-items: center;
		.swiper-slide:first-child {
			margin-left: 0em;
		}
	}
`;

export const InfoCard = styled.div`
	width: 16.25em;
	height: 14.56em;
	border-radius: 1.1em;
	background: #f5f6f8;
	box-shadow: 0 0.32em 1em 0 rgba(0, 0, 0, 0.25);
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: space-between;
	padding: 1em;
	box-sizing: border-box;

	&.isFriendInvite {
		gap: 0.5em;
	}
`;

export const InfoCardImage = styled.img<{ isFriendInvite?: boolean }>`
	width: 100%;
	height: 70%;
	border-radius: 16px;
	//object-fit: contain;

	&.isFriendInvite {
		height: 61%;
	}
`;

export const InfoCardText = styled(Typography)`
	font-size: 1.4em;
	line-height: 1em;
	font-family: Baloo;
	text-align: center;
	color: #113b62;
`;

export const Text = styled.div`
	font-family: Baloo;
	-webkit-text-stroke-width: 0.12em;
	-webkit-text-stroke-color: #000;
	paint-order: stroke fill;
	color: #fff;
	filter: drop-shadow(0 0.049em 0 #000);
	font-style: normal;
	font-weight: 400;
`;

export const Title = styled(Text)`
	margin-top: 1.3em;
	font-size: 2.125em;
	line-height: 0.9em;
	font-weight: 400;
	width: 100%;
	//padding: 0 1.5em;
	text-align: center;
	color: #fbbd05;

	@media (orientation: landscape) {
		margin-top: 0.72em;
		font-size: 3.25em;
	}
`;

export const CustomButton = styled(Button)`
	width: 94%;
	margin-top: 0.5em;
	height: 3.2em;
	font-size: 1em;
	text-transform: none;

	@media (orientation: landscape) {
		margin-top: 0.5em;
		width: 18.5em;
		height: 3.62em;
	}
`;
